<template>
<div class="MGJHome">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="animated fadeIn" v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view></router-view> -->
    <div class="loading" v-show="loading">
        <van-loading vertical type="spinner" color="#1989fa"><span style="font-size: 0.24rem">加载中...</span>
        </van-loading>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {wxLogin} from 'common/js/mixin'
import "animate.css/animate.min.css"
export default {
    name: 'MGJHome',
    mixins: [wxLogin],
    data() {
        return {
        }
    },
    created() {
        if (this.ClientType === 1) {
            this.setClientType(2)
        }
    },
    mounted() {},
    methods: {
        ...mapActions(['setClientType'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading', 'ClientType', 'domainlist'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/index";
.MGJHome {
    min-height: 100vh;
    font-size: 0.24rem;
    width: 100%;
    background: $c-global;
    // background:rgba(245,247,250,1);
    input {
        -webkit-appearance: none;
        border: none;
        outline: none;
    }
    .loading {
        @include flexBox(center);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .2);
        z-index: 10000;
    }
    img[lazy='loading'], img[lazy=error] {
        width: 0.64rem !important;
        height: 0.64rem !important;
    }
    .animated {
        // margin-top: 50px;
        animation: animatedmargin .5s;
        -webkit-animation: animatedmargin .5s;
        -ms-animation: animatedmargin .5s;
        -moz-animation: animatedmargin .5s;
        -o-animation: animatedmargin .5s;
    }
    @keyframes animatedmargin {
        0% {
            margin-top: 20px;
            opacity: 0;
        }
        100% {
            margin-top: 0;
            opacity: 1;
        }
    }
}
</style>